import { css } from '@emotion/css'

import { borderRadius, fontFamily, fontSize, fontWeight, spacing, zIndex } from '../../../styles'
import { shorthandHelper } from '../../../styles/helpers'
import { colors } from '../../../themes'
import { hexToRgba } from '../../../themes/helpers'

const styles = {
  button: css({
    boxSizing: 'border-box',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    border: `1px solid ${colors.amethyst}`,
    borderRadius: borderRadius.default,
    color: colors.amethyst,
    fontFamily: fontFamily.body,
    fontWeight: fontWeight.regular,
    fontSize: fontSize.small,
    lineHeight: 1.4,
    whiteSpace: 'nowrap',
    height: 30,
    padding: shorthandHelper([spacing.small, spacing.default]),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: zIndex.level2, // so that the button is above positionSelect overlay
    minWidth: 105, // width of button with 'Unfavourite' as text

    '&:hover': {
      backgroundColor: colors.whiteLilac,
    },

    '&:focus': {
      outline: 'none',
    },

    '&:active': {
      backgroundColor: hexToRgba(colors.amethyst, 0.25),
    },

    '&[disabled]': {
      opacity: 0.3,
      pointerEvents: 'none',
    },
  }),

  icon: css({
    marginRight: spacing.small,
  }),
}

export default styles
